// extracted by mini-css-extract-plugin
export default {"EventDetails":"Ohl5mAkJNuJzDgpIzlEo","EventDetails_Badges":"_hwkVgZE_qwwKnS6LrTb","EventDetails_Info":"KOdh7vdtftC5oUBw7dm0"};